import { DimensionType, IInventoryItem } from 'gen/ApiClient';

export function formatSizeOrLength(item: IInventoryItem): string {
	return (item.dimensionType as DimensionType) === 'Length' ? `${item.lengthInCm.toString()} cm` : item.size.toString();
	// return hasLength(item.type as InventoryType) ? `${item.lengthInCm.toString()} cm` : item.size.toString();
}
